import PersonAvatarIcon from '@atlaskit/icon/core/person-avatar';
import * as React from 'react';

export function SvgAccount() {
  return <PersonAvatarIcon label="" testId="ads-refreshed-icon" />;
}
